import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { EditIcon, UserIcon2, PlusIcon, CalendarIcon2, DocumentIcon2 } from '../components/shared/Icons';
import FilterPeriodical from './FilterPeriodical';
import FilterReplacement from './FilterReplacement';
import FilterLeave from './FilterLeave';
import FilterSouthYarra from './FilterSouthYarra';
import FilterExtrawork from './FilterExtrawork';
import NewPeriodical from './NewPeriodical';
import Extrawork from './Extrawork';
import NewRequestLeave from './NewRequestLeave';
import NewReplacement from './NewReplacement';
import CleanersCard from './CleanersCard';
import CalendarIframe from './CalendarIframe';
import UniformForm from './UniformForm';
import RecordMeetingForm from './RecordMeetingForm';
import UnderperformanceForm from './UnderperformanceForm';
import PerformanceImprovementForm from './PerformanceImprovementForm';
import VendorCreationForm from './VendorCreationForm';
import FilterTickets from './FilterTickets';
import TestNTag from './TestNTag';
import SitesManagement from './SitesManagement';







const TABS = [
  {
    id: 'workflow',
    label: 'Add',
    
  },
  {
    id: 'update',
    label: 'Updates',
    
  },
  {
    id: 'calendar',
    label: 'Calendar',
    
  },
  {
    id: 'recruitment',
    label: 'Recruitment',
  },
  {
    id: 'documents',
    label: 'Staff Forms',
  },
  
];

const WORKFLOW_INNER = [
  { id: 'leave', label: 'Leave', icon: <PlusIcon />, component: NewRequestLeave },
  { id: 'replacement', label: 'Replacement', icon: <PlusIcon />, component: NewReplacement },
  { id: 'extrawork', label: 'Extra Work', icon: <PlusIcon />, component: Extrawork },
  { id: 'periodical', label: 'Periodical', icon: <PlusIcon />, component: NewPeriodical },
  { id: 'sitesall', label: 'Manage Clients', icon: <UserIcon2 />, component: SitesManagement },
];


const UPDATE_INNER = [
  { id: 'leaveupdate', label: 'Leave', icon: <EditIcon />, component: FilterLeave },
  { id: 'replacementupdate', label: 'Replacement', icon: <EditIcon />, component: FilterReplacement },
  { id: 'extraworkupdate', label: 'Extra Work', icon: <EditIcon />, component: FilterExtrawork },
  { id: 'periodicalupdate', label: 'Periodical', icon: <EditIcon />, component: FilterPeriodical },
  { id: 'southyarraupdate', label: 'South Yarra', icon: <EditIcon />, component: FilterSouthYarra },
  { id: 'ticketupdate', label: 'Ticket', icon: <EditIcon />, component: FilterTickets },
   { id: 'testntagupdate', label: 'TestNTag', icon: <EditIcon />, component: TestNTag },
];



const CALENDAR_INNER = [
  { id: 'leavecalendar', label: 'Leave', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appinITusLeUE9ifR/shrj7OGp34El7m0Rq?backgroundColor=dark" /> },
  { id: 'replacementcalendar', label: 'Replacement', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appinITusLeUE9ifR/shr1pJBWYexwWbpji?backgroundColor=dark" /> },
  { id: 'extraworkcalendar', label: 'Extra Work', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appj4V5zaWcFiR7NM/shrBpJJGWJBe805v7?backgroundColor=dark" /> },
  { id: 'periodicalcalendar', label: 'Periodical', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appciHwOR34Suu6Qm/shrlwzfqjvHXWaVcL?backgroundColor=dark" /> },
  { id: 'southyarracalendar', label: 'South Yarra', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/apprjJS4aecux6Cf1/shrv09STVpiDCFpQY?backgroundColor=dark" /> },
  { id: 'ticketcalendar', label: 'Ticket', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appUbsPnUAWdyKLEC/shrwa9EFvZh0NgL20?backgroundColor=dark" /> },
];

const CLEANER_INNER = [
  { id: 'current', label: 'Current', icon: <UserIcon2 />, component: () => <CleanersCard template="1" /> },
  { id: 'active', label: 'Active', icon: <UserIcon2 />, component: () => <CleanersCard template="2" /> },
  { id: 'notactive', label: 'Not Active', icon: <UserIcon2 />, component: () => <CleanersCard template="3" /> },
];



const FORMS_INNER = [
  { id: 'male-uniform', label: 'Male Uniform', icon: <DocumentIcon2 />, component: () => <UniformForm variant="male" /> },
  { id: 'female-uniform', label: 'Female Uniform', icon: <DocumentIcon2 />, component: () => <UniformForm variant="female" /> },
  { id: 'record-meeting', label: 'Record Meeting', icon: <DocumentIcon2 />, component: RecordMeetingForm },
  { id: 'underperformance', label: 'Underperformance', icon: <DocumentIcon2 />, component: UnderperformanceForm },
  { id: 'improvement', label: 'Improvement Plan', icon: <DocumentIcon2 />, component: PerformanceImprovementForm },
  { id: 'vendor', label: 'Vendor', icon: <DocumentIcon2 />, component: VendorCreationForm },
];





const FiltersSupervisorPage = () => {
  const [activeTab, setActiveTab] = useState("workflow");
  const { homeAccent } = useUser();

  

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'workflow' && <InnerTabsd tabs={WORKFLOW_INNER} defaultId="leave"/>}
        {activeTab === 'update' && <InnerTabsd tabs={UPDATE_INNER} />}
        {activeTab === 'calendar' && <InnerTabsd tabs={CALENDAR_INNER} />}
        {activeTab === 'recruitment' && <InnerTabsd tabs={CLEANER_INNER} />}
        {activeTab === 'documents' && <InnerTabsd tabs={FORMS_INNER} />}
        
      </div>
    </div>
  );
};



export default FiltersSupervisorPage;